import {useTranslation} from "next-i18next";
import Image from "next/image";
import Button from "./Button";
import { Trans } from "next-i18next";

export default function HomeKaufenUndVerkaufen() {
  const {t} = useTranslation();

  return (
    <div className="w-full flex flex-col items-center relative w-full -mt-[1px]">
        <Image
            src="/images/home-kaufen-und-verkaufen.png"
            title="Buy and sell"
            alt="Buy and sell"
            fill
            className="w-full object-cover -z-[1]"
        />
        <div className="w-full h-full  z-1 top-0 left-0 flex flex-col justify-around items-center text-white py-8 md:py-12 gap-6">
          <div className="flex flex-col justify-center items-center text-center max-w-full lg:max-w-[65%] w1440:max-w-[50%]">
            <h2 className="font-light text-[24px] md:text-[55px] leading-[1.3] w-[50%] md:w-full">{t("buyAndSell.heading")}</h2>
            <div className="relative aspect-square w-[60%] lg:w-full max-w-[300px] mt-4 md:mt-2 mb-6">
              <Image
                  src="/images/home-kaufen-und-verkaufen-main.png"
                  title="Buy and sell main"
                  alt="Buy and sell main"
                  fill
                  className="w-full"
              />
            </div>
            <p className="leading-[1.4] text-[12px] md:text-[18px]">
              <Trans i18nKey="buyAndSell.paragraph1_line1" components={{ br: <br />, strong: <strong /> }} />
            </p>
            <p className="leading-[1.4] text-[12px] md:text-[18px]">
              <Trans i18nKey="buyAndSell.paragraph1_line2" components={{ br: <br />, strong: <strong /> }} />
            </p>
          </div>

          <div className="flex flex-col justify-center items-center text-center max-w-full lg:max-w-[65%] w1440:max-w-[50%] px-4 ">
            <p className="leading-[1.4] text-[12px] md:text-[18px]">
              <Trans i18nKey="buyAndSell.paragraph2_line1" components={{ br: <br />, strong: <strong /> }} />
            </p>
            <p className="leading-[1.4] text-[12px] md:text-[18px]">
              <Trans i18nKey="buyAndSell.paragraph2_line2" components={{ br: <br />, strong: <strong /> }} />
            </p>
            <p className="leading-[1.4] text-[12px] md:text-[18px]">
              <Trans i18nKey="buyAndSell.paragraph2_line3" components={{ br: <br />, strong: <strong /> }} />
            </p>
            <p className="leading-[1.4] text-[12px] md:text-[18px] mb-6 md:mb-8">
              <Trans i18nKey="buyAndSell.paragraph2_line4" components={{ br: <br />, strong: <strong /> }} />
            </p>
            <Button
              className="text-[14px] md:text-[16px] bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300 w-auto rounded-[10px]"
              text={t("buyAndSell.buttonLabel")}
              transparent={false}
              border={false}
              textColor={"text-white"}
              href={"/kontakt"}
              textTransform="uppercase font-semibold"
              padding={"px-4 md:px-6 py-2"}
              hoverTextColor={"text-white"}
            />
          </div>
        </div>
    </div>
  );
}